// What's-new entries shown in the home header banner + WhatsNew
// sheet. Newest first. `id` is the storage key used to remember
// which entries the user has acknowledged. Bump entries with a
// fresh `id` (date-ish slug is fine) to surface them to returning
// users without forcing a modal.
//
// title and body are i18n keys resolved through src/locales/strings.js.
// Keep copy short — one phrase for the title, one or two sentences
// for the body.
//
// `since` is an ISO date string. Entries older than the user's
// `auth.users.created_at` are filtered out so a brand-new signup
// doesn't see "what's new" copy about features they have never
// known to be different. Always include a `since` when adding an
// entry; `entriesForUser()` is the canonical filter.

export const WHATS_NEW = [
  {
    id: 'new_nav_2026_05',
    since: '2026-05-07',
    title: 'wn_new_nav_title',
    body:  'wn_new_nav_body',
  },
  {
    id: 'intro_redesign_2026_05',
    since: '2026-05-02',
    title: 'wn_intro_redesign_title',
    body:  'wn_intro_redesign_body',
  },
];

// Returns the entries the given user is allowed to see. A null /
// undefined `userCreatedAt` is treated as a returning user (we
// have no signup date so we err on the side of showing
// everything). An invalid date does the same.
export function entriesForUser(userCreatedAt) {
  if (!userCreatedAt) return WHATS_NEW;
  const ms = Date.parse(userCreatedAt);
  if (Number.isNaN(ms)) return WHATS_NEW;
  return WHATS_NEW.filter((e) => {
    const sinceMs = Date.parse(e.since);
    if (Number.isNaN(sinceMs)) return true;
    return sinceMs >= ms;
  });
}

// Latest entry id for the given user. Used by hasUnreadWhatsNew
// to decide whether to show the banner.
export function latestWhatsNewIdForUser(userCreatedAt) {
  const list = entriesForUser(userCreatedAt);
  return list[0]?.id || null;
}

// Back-compat: the previous API didn't take a user. Kept so
// existing call sites that don't yet thread the user through
// keep compiling. Prefer the *ForUser variants in new code.
export function latestWhatsNewId() {
  return WHATS_NEW[0]?.id || null;
}
